/*eslint-disable no-unused-vars */
/*eslint-disable no-use-before-define */
import React from 'react';
import { Button } from 'react-bootstrap';
import '../Button.scss';

//variant : 'primary' | 'secondary'

const GenericButton = (props) => {
  const {
    children,
    variant = 'primary',
    className: cssClass,
    preLabel = 'preLabel',
    postLabel = postLabel,
    disable = disable,
    ...restProps
  } = props;
  let className =
    variant === 'secondary'
      ? 'secondary-button'
      : variant === 'link'
      ? 'link-button'
      : '';

  if (disable) {
    className += ' disabled-button';
  }
  className += ` ${cssClass}`;

  return (
    <Button
      type={restProps.type}
      key={props.disable}
      bsPrefix="generic-primary-button"
      className={className}
      onClick={props.onClick}
      disabled={disable}
    >
      <div>
        {disable && (
          <span
            className="spinner-border"
            role="status"
            aria-hidden="true"
          ></span>
        )}
        {!disable ? (
          <span className="btn-label">{children ? children : preLabel}</span>
        ) : (
          <span className="btn-label">{postLabel}</span>
        )}
      </div>
    </Button>
  );
};

export default GenericButton;
